import { API_BASE } from "../config/api";
import { useCallback, useEffect, useState } from "react";
export const SESSION_KEY = "serena.admin.token";
const base = API_BASE;
export default function useAdminSession() {
  const [session, setSession] = useState(null);
  const [checking, setChecking] = useState(true);
  const [error, setError] = useState("");
  const [revision, setRevision] = useState(0);
  const logout = useCallback(() => {
    try { localStorage.removeItem(SESSION_KEY); } catch { /* storage may be unavailable */ }
    setSession(null); setError(""); setChecking(false); setRevision(value => value + 1);
  }, []);
  const login = useCallback(value => {
    try { localStorage.setItem(SESSION_KEY, value.token); }
    catch { throw new Error("Il browser non consente di salvare la sessione. Abilita lo storage per questo sito."); }
    setSession(value); setError(""); setChecking(false);
  }, []);
  useEffect(() => {
    const controller = new AbortController();
    async function restore() {
      let token;
      try { token = localStorage.getItem(SESSION_KEY); } catch { setChecking(false); return; }
      if (!token) { setSession(null); setChecking(false); return; }
      setChecking(true); setError("");
      try {
        const response = await fetch(`${base}/api/users/me`, { headers: { Authorization: `Bearer ${token}` }, signal: controller.signal, cache: "no-store" });
        if (controller.signal.aborted) return;
        if (response.status === 401 || response.status === 403) { logout(); return; }
        if (!response.ok) throw new Error("Impossibile verificare la sessione. Riprova tra poco.");
        const data = await response.json();
        if (controller.signal.aborted) return;
        if (!data.data?.user) throw new Error("Risposta del servizio non valida.");
        if (data.data.user.role !== "admin") { logout(); return; }
        setSession({ token, user: data.data.user });
      } catch (failure) {
        if (!controller.signal.aborted) setError("Connessione al servizio non disponibile. La sessione salvata è stata conservata.");
      } finally { if (!controller.signal.aborted) setChecking(false); }
    }
    restore();
    return () => controller.abort();
  }, [revision, logout]);
  useEffect(() => {
    function sync(event) { if (event.key === SESSION_KEY || event.key === null) { setSession(null); setChecking(true); setRevision(value => value + 1); } }
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);
  return { session, checking, error, login, logout, retry: () => setRevision(value => value + 1) };
}

